import { Component, Input, OnInit } from '@angular/core';
import { CentroSaludParbulos } from 'src/app/model/ReglamentoInterno.model';

@Component({
  selector: 'app-centros-salud-reglamento',
  templateUrl: './centros-salud-reglamento.component.html',
  styleUrls: ['./centros-salud-reglamento.component.css']
})
export class CentrosSaludReglamentoComponent implements OnInit {

  
  @Input() centroSaludParbulos : CentroSaludParbulos;
  @Input() readonly : boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
